(() => {
  let viewerPromise;
  const loadViewer = (src) => {
    if (customElements.get('model-viewer')) return Promise.resolve();
    if (!viewerPromise) viewerPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.type = 'module'; script.src = src;
      script.onload = () => customElements.whenDefined('model-viewer').then(resolve);
      script.onerror = () => { script.remove(); viewerPromise = null; reject(new Error('viewer-load')); };
      document.head.append(script);
    });
    return viewerPromise;
  };
  if (customElements.get('le-product-model')) return;
  customElements.define('le-product-model', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort(); this.controller = new AbortController();
      const signal = this.controller.signal;
      this.querySelector('[data-model-open]').addEventListener('click', () => this.open(), {signal});
      this.querySelector('[data-model-close]').addEventListener('click', () => this.close(), {signal});
      this.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); }, {signal});
    }
    async open() {
      if (this.busy || this.viewer) return;
      this.busy = true;
      const open = this.querySelector('[data-model-open]');
      const status = this.querySelector('[data-model-status]');
      open.disabled = true; status.textContent = this.dataset.loading;
      try {
        await loadViewer(this.dataset.library);
        if (!this.isConnected) return;
        const viewer = document.createElement('model-viewer');
        viewer.setAttribute('camera-controls', ''); viewer.setAttribute('touch-action', 'pan-y');
        viewer.setAttribute('max-camera-orbit', 'auto auto 200%');
        viewer.setAttribute('camera-orbit', '17deg 83deg 0.82m');
        viewer.setAttribute('field-of-view', '30deg');
        viewer.setAttribute('alt', this.dataset.alt); viewer.setAttribute('tabindex', '0');
        viewer.setAttribute('interaction-prompt', 'none');
        viewer.setAttribute('shadow-intensity', '0.4');
        viewer.setAttribute('shadow-softness', '1');
        viewer.addEventListener('load', () => { status.textContent = ''; this.querySelector('[data-model-close]').focus(); }, {once:true});
        viewer.addEventListener('error', () => { this.close(false); status.textContent = this.dataset.error; }, {once:true});
        this.viewer = viewer; this.querySelector('[data-model-stage]').append(viewer);
        this.classList.add('is-open'); this.querySelector('[data-model-close]').hidden = false;
        viewer.src = this.dataset.src;
      } catch (_) { status.textContent = this.dataset.error; }
      finally { this.busy = false; open.disabled = false; }
    }
    close(focus = true) {
      this.viewer?.remove(); this.viewer = null; this.classList.remove('is-open');
      this.querySelector('[data-model-close]').hidden = true;
      this.querySelector('[data-model-status]').textContent = '';
      if (focus) this.querySelector('[data-model-open]').focus();
    }
    disconnectedCallback() { this.controller?.abort(); this.viewer?.remove(); this.viewer = null; }
  });
})();
